import {
  CalendarOutlined,
  EditOutlined,
  HomeOutlined,
  LaptopOutlined,
  // MoneyCollectOutlined,
  UserOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { ROUTES } from "Constants/AllRoutes";

export const sidebarItems = [
  {
    label: "Home",
    key: "0",
    target: ROUTES.DASHBOARD_HOME,
    icon: <HomeOutlined style={{ fontSize: "18px" }} />,
  },
  {
    label: "My Calendar",
    key: "1",
    target: ROUTES.MY_CALENDAR,
    icon: <CalendarOutlined style={{ fontSize: "18px" }} />,
  },
  {
    label: "Manage Slots",
    key: "2",
    icon: <LaptopOutlined style={{ fontSize: "18px" }} />,
    children: [
      {
        label: "Publish Slots",
        key: "2.1",
        icon: <VideoCameraOutlined style={{ fontSize: "18px" }} />,
        target: ROUTES.PUBLISH_SLOTS,
      },
      {
        label: "Edit Slots",
        key: "2.2",
        icon: <EditOutlined style={{ fontSize: "18px" }} />,
        target: ROUTES.EDIT_SLOTS,
      },
    ],
  },
  // {
  //   label: "Payments",
  //   key: "2",
  //   target: ROUTES.PAYMENTS,
  //   icon: <MoneyCollectOutlined style={{ fontSize: "18px" }} />,
  // },
  {
    label: "Profile",
    key: "4",
    target: ROUTES.PROFILE,
    icon: <UserOutlined style={{ fontSize: "18px" }} />,
  },
];
